import React, { useRef } from 'react';

import { AgGridClient } from 'common/components';

import * as utils from './utils';

import { useManageScheduleDownloadQuery } from 'hooks/folders/queries';

const containerStyle = {
  height: '100%',
};

const ManageScheduleDownloadGrid = (props) => {
  const gridRef = useRef();
  const { folderId, setSelectedSchedule } = props;

  const { data } = useManageScheduleDownloadQuery({ folderId });

  const scheduleList = data?.schedules;

  const columns = utils.getColumns();

  const onSelectionChangedHandler = (e) => {
    const selectedRow = gridRef.current.api.getSelectedRows();
    setSelectedSchedule(selectedRow?.[0]);
  };

  return (
    <AgGridClient
      rowData={scheduleList}
      refGrid={gridRef}
      columnDefs={columns}
      rowSelection='single'
      containerStyle={containerStyle}
      onSelectionChanged={onSelectionChangedHandler}
    />
  );
};

export default ManageScheduleDownloadGrid;
